const accessToken = (state) => state.accessToken;
const userName = (state) => state.userName;

export default {
  accessToken,
  userName,
};
